import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "../Pages/Login";
import Sidebar from "../Dashboard/Sidebar";
import CreditReport from "../Dashboard/CreditReport";
import BasicDetails from "../loginFlow/BasicDetails";
import OtpVerification from "../loginFlow/OtpVerification";
import ExperianFullForm from "../loginFlow/ExperianFullForm";
import MySettlement from "../Dashboard/MySettlement";
import ContactusPage from "../Dashboard/ContactusPage";
import FaqComponents from "../Dashboard/FaqComponents";
import Profile from "../Dashboard/Profile";
import AboutUs from "../Pages/AboutUs";
import SettleOffer from "../Dashboard/SettleOffer";
import TermsConditions from "../Pages/TermsConditions";
import RequireAuth, { RequireLS } from "./RequireAuth";
import PageNotFound from "../Pages/PageNotFound";
import HelmetWrapper from "../Dashboard/HelmetWrapper";
import SlashRedirect from "./SlashRedirect";
import PremiumDashboard from "../Dashboard/PremiumDashboard";
import AuthPermission from "../service/Permissions/Auth.per";
import LandingDashboard from "../Pages/Dashboard/LandingDashboard";
import LandingPageAnimation from "../Home2/LandingPageAnimation";
import GrievanceRedressal from "../Pages/GrievanceRedressal/GrievanceRedressal";
import ScrollToTop from "./ScrollToTop";
import RedirectIfAuthenticated from "./RedirectIfAuthenticated"
import RequireStatus from "./RequireStatus";
// import LoadingScreen from "../utils/LoadingScreen";
// import ProfileScreen from "../Components/Profile/ProfileScreen";
import CreditInsightScreen from "../Components/CreditInsight/CreditInsightScreen";
import BadLoanScreen from "../Pages/Dashboard/BadloanScreen";
// import decryptValues from "../utils/decryptValues";
import DownloadCreditReport from "../Pages/Dashboard/Download/DownloadCreditReport"
import ExperianConsent from "./ExperianConsent";
// import SubDomainLandScreen from "../Pages/SbiSubdomain/SubDomainLandScreen";
// import ThankYou from "../Pages/SbiSubdomain/ThankYou";
import RecommendationScreen from '../Pages/Recommendations/Recommendation'
function AppRoutes() {
  const allowedStatuses = [
    "ENHANCED_FETCH_REPORT_OTP_VALIDATED",
    "NORMAL_FETCH_REPORT_OTP_SENT",
    "NORMAL_FETCH_REPORT_OTP_VALIDATED",
    "ENHANCED_FETCH_FORM_SUBMITTED",
    "NORMAL_FETCH_FORM_SUBMITTED"
  ];
  const allowedStatusesNormal = [
    "ENHANCED_FETCH_REPORT_OTP_SENT",
    "REVOKE_CONSENT",
    "BUREAU_DELETED",
    "OTP_VALIDATED",
    null,
  ];


  function StatusProtectedRoute({ children }) {
    // const StatusLS = decryptValues({key:"StatusLS"})
    const StatusLS = localStorage.getItem("StatusLS");

    if (!allowedStatuses.includes(StatusLS)) {
      return <Navigate to="/PageNotFound" replace />;
    }
    return children;
  }

  function StatusProtectedRouteNormal({ children }) {
    let StatusLS = localStorage.getItem("StatusLS");

    // const StatusLS = decryptValues({key:"StatusLS"})

    if (StatusLS === "null") {
      StatusLS = null;
    }
    if (StatusLS == null || allowedStatusesNormal.includes(StatusLS)) {
      return children;
    }

    return <Navigate to="/PageNotFound" replace />;
  }


  return (
    <BrowserRouter>
      <SlashRedirect>
        <ScrollToTop />
        <HelmetWrapper />
        <Routes>
          <Route element={<LandingPageAnimation />} path="/" />
          <Route element={<RecommendationScreen />} path="/recommendations" />
          {/* delete this /loadingScreen route after testing */}
          {/* <Route element={<LoadingScreen />} path="/loadingScreen" /> */}

          <Route
            element={
              <RedirectIfAuthenticated>
                <Login />
              </RedirectIfAuthenticated>
            }
            path="/login" />
          <Route path="/login/user" element={<StatusProtectedRouteNormal><RequireAuth><RequireLS ><BasicDetails /></RequireLS></RequireAuth></StatusProtectedRouteNormal>} />

          <Route path="/login/otpverification" element={<RequireAuth><RequireLS ><OtpVerification /></RequireLS></RequireAuth>} />
          <Route path="/login/experianfullform" element={<StatusProtectedRoute><RequireAuth><RequireLS ><ExperianFullForm /></RequireLS></RequireAuth> </StatusProtectedRoute>} />

          <Route path="/creditdetails" element={<RequireAuth><PremiumDashboard /></RequireAuth>} />
          {/* <Route path="/SubDomainLandScreen" element={<RequireAuth><SubDomainLandScreen/></RequireAuth>} />
          <Route path="/thank-you" element={<RequireAuth><ThankYou/></RequireAuth>} /> */}




          <Route element={<AboutUs />} path="/about-us" />

          <Route path="/contact-us" element={<ContactusPage />} />
          <Route path="/terms-&-conditions" element={<TermsConditions />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/experian-consent" element={<ExperianConsent />} />


          <Route path="/faq" element={<FaqComponents />} />
          <Route path="/*" element={<PageNotFound />} />
          <Route path="/grievance-redressal" element={<GrievanceRedressal />} />
          <Route path="/dashboard" element={<RequireStatus> <RequireAuth><Sidebar /></RequireAuth> </RequireStatus>}>
            <Route index element={<Navigate to="reports" replace />} />
            <Route path="reports" element={<CreditReport />} />
            <Route path="settlement" element={<MySettlement />} />
            <Route path="profile" element={<Profile />} />
            <Route path="offer/:id" element={<SettleOffer />} />
            <Route path="terms-and-conditions" element={<TermsConditions />} />
          </Route>
          <Route path='/home' element={<AuthPermission />}>
            <Route path="/home" element={<Navigate to="/home/dashboard" replace />} />
            <Route index path="/home/dashboard/" element={<LandingDashboard />} />
            <Route index path="/home/dashboard" element={<LandingDashboard />} />
            <Route path="/home/insights" element={<CreditInsightScreen />} />
            <Route path="/home/badloans" element={<BadLoanScreen />} />
            <Route path="/home/settlement" element={<MySettlement />} />
            <Route path="/home/profile" element={<Profile />} />
            <Route path="/home/download" element={<DownloadCreditReport />} />
            <Route path="*" element={<div><h1>page not found</h1></div>} />
          </Route>
        </Routes>
      </SlashRedirect>
    </BrowserRouter>
  );
}

export default AppRoutes;
